import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import DiplomasTable from '@app/components/shared/DiplomasTable'
import Placeholder from '@app/components/ui/placeholders/Placeholder'
import Api from '@app/api'

const Diplomas = ({ diplomas, event_id }) => {
  return (
    <div className="page">
      <DiplomasTable
        diplomas={diplomas[event_id]}
        applicableFor="parent"
        downloadArchiveLink={Api.parents.diplomas.download.path}
      />
    </div>
  )
}

Diplomas.propTypes = {
  diplomas: PropTypes.object.isRequired,
  event_id: PropTypes.string.isRequired
}

export default Diplomas
